import React from 'react'
import Deposit from '../../component/deposit/index'


export function Depositt() {
  return (
    <>
      <Deposit />
    </>
  )
}
